export default __webpack_public_path__ + "static/media/base-report8.490235b1.png";